import { createRouter, createWebHistory } from 'vue-router'

import Home from '../pages/Home.vue'
import ProductsPage from '../pages/ProductsPage.vue'
import ProductDetails from '../pages/ProductDetails.vue'
import DocumentsPage from '../pages/DocumentsPage.vue'

const routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/products', name: 'products', component: ProductsPage },
  { path: '/products/:id', name: 'product-details', component: ProductDetails, props: true },
  { path: '/documents', name: 'documents', component: DocumentsPage }
]

const HEADER_HEIGHT = 65

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition

    if (to.hash) {
      // Use manual scroll for better control
      return new Promise((resolve) => {
        setTimeout(() => {
          const el = document.querySelector(to.hash)
          if (el) {
            const y = el.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT
            window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' })
          }
          resolve(false)
        }, 0)
      })
    }

    // Only scroll to top when actually changing pages
    if (to.path !== from.path) {
      return { top: 0, behavior: 'smooth' }
    }

    return false
  }
})
